module.exports = __webpack_public_path__ + "img/tx1.524aabc7.jpg";